import React, { createContext, useContext, useEffect, useState } from "react";

const AllDivisionContext = createContext([]);

export const ApiProvider = ({ children }) => {
  const [companyId, setCompanyId] = useState(() => {
    return localStorage.getItem("company_id") || "";
  });
   const [affiliate_code, setAffiliate_code] = useState(() => {
    return localStorage.getItem("affiliate_code") || "";
  });
  const [phoneNo, setPhoneNo] = useState(() => {
    return localStorage.getItem("phoneNo") || "";
  });
  const [name, setName] = useState(() => {
    return localStorage.getItem("name") || "";
  });
  const [email, setEmail] = useState(() => {
    return localStorage.getItem("email") || "";
  });
  const [loader, setLoader] = useState("");
  const [allowAdvancedKyc, isAllowAdvancedKyc] = useState(false);
  const [basicKyc, setBasicKyc] = useState(false);
  const [advancedKyc, setAdvancedKyc] = useState(false);
  const [entityType, setEntityType] = useState("Proprietorship");

  // ✅ Keep localStorage in sync when companyId changes
  useEffect(() => {
    if (companyId) {
      localStorage.setItem("company_id", companyId);
    }
  }, [companyId, phoneNo]);

  return (
    <AllDivisionContext.Provider
      value={{
        setCompanyId,
        companyId,
        setLoader,
        loader,
        allowAdvancedKyc,
        isAllowAdvancedKyc,
        basicKyc,
        setBasicKyc,
        entityType,
        setEntityType,
        phoneNo,
        setPhoneNo,
        name,
        setName,
        email,
        setEmail,
        affiliate_code,
        setAffiliate_code
      }}
    >
      {children}
    </AllDivisionContext.Provider>
  );
};

export const useAllProduct = () => {
  const context = useContext(AllDivisionContext);
  if (!context) {
    throw new Error("useAllProduct must be used within an ApiProvider");
  }
  return context;
};

export default AllDivisionContext;
